import _isEmpty from 'lodash/isEmpty';

import { formatStyleRuleName } from '../../services/format';

export function createStyleRuleHierarchyOptions(hierarchy, hierarchySet) {
  return hierarchy.reduce((acc, segment, index) => {
    const currentHierarchy = hierarchy.slice(0, index + 1);
    const hierarchyKey = currentHierarchy.join('.');

    if (!hierarchySet.has(hierarchyKey)) {
      hierarchySet.add(hierarchyKey);
      acc.push({ styleRule: null, hierarchy: currentHierarchy });
    }

    return acc;
  }, []);
}

export function extractStyleRuleSearchOptions(styleRuleConfigurations) {
  const hierarchySet = new Set();
  return styleRuleConfigurations.flatMap(({ name, hierarchy }) => {
    const hierarchyOptions = createStyleRuleHierarchyOptions(hierarchy, hierarchySet);
    return [...hierarchyOptions, { styleRule: name, hierarchy }];
  });
}

export function formatStyleRuleSearchOptions(intermediateOptions) {
  return intermediateOptions.map(({ styleRule, hierarchy }) => ({
    key: `${hierarchy.join('.')}-${styleRule || ''}`,
    value: styleRule || hierarchy.join('.'),
    text: styleRule
      ? formatStyleRuleName(styleRule)
      : hierarchy.map(formatStyleRuleName).join(' / '),
    icon: styleRule ? 'at' : 'folder outline',
  }));
}

export function createStyleRuleSearchOptions(styleRuleConfigurations) {
  if (_isEmpty(styleRuleConfigurations)) {
    return [];
  }

  const intermediateOptions = extractStyleRuleSearchOptions(styleRuleConfigurations);
  return formatStyleRuleSearchOptions(intermediateOptions);
}
